import React, { Suspense, useRef, ReactNode, FC, HTMLAttributes, memo, CSSProperties } from "react";
import { useIntersectionObserver } from "@src/hooks/useIntersectionObserver";
import { cn } from "../../utils/ui";
import { propsEqualityFn } from "@src/utils/object-utils/object-utils";

interface RenderOnViewportEntryProps extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode;
    className?: string;
    rootMargin?: string;
    style?: CSSProperties;
}

const RenderOnViewportEntry: FC<RenderOnViewportEntryProps> = (props) => {
    const { children, className = '', style } = props;
    const ref = useRef<HTMLDivElement>(null);
    const rootMargin = props.rootMargin || `0px 0px ${window.innerHeight}px 0px`;
    const { inView } = useIntersectionObserver(ref, { threshold: 0, rootMargin, triggerOnce: true });

    return (
        <div className={cn('', className)} ref={ref} style={style}>
            {inView && <Suspense fallback={null}>{children}</Suspense>}
        </div>
    );
};

export default memo(RenderOnViewportEntry, propsEqualityFn);
